import MstWarehouseComponent from '../Components/Master/Warehouse.tsx';
import { getPageFunction, pageEnum } from '../../security/LoginDetail.js';
import { Suspense } from 'react';
import { useLoaderData, Await } from 'react-router-dom';
import { GET_BU_LIST_URL } from '../../const/APIUrl.js';
import { fetchAPI } from '../../api/GenericFetch.js';

export default function MstWarehouse(){
    const pageFunction = getPageFunction({pageId : pageEnum.MstWarehouse});
    const locationList = useLoaderData();
    return (        
        <Suspense>
            {<Await resolve={locationList}>
                {(locationList) => <MstWarehouseComponent locationList={locationList} pageFunction={pageFunction}/>}
            </Await> }
        </Suspense>
    );
}

export async function loader() {
    return fetchAPI({url:GET_BU_LIST_URL});
}
